import { render, staticRenderFns } from "./WfConsumerCorpGroupList.vue?vue&type=template&id=15a7bd23&scoped=true&"
import script from "./WfConsumerCorpGroupList.vue?vue&type=script&lang=js&"
export * from "./WfConsumerCorpGroupList.vue?vue&type=script&lang=js&"
import style0 from "./WfConsumerCorpGroupList.vue?vue&type=style&index=0&id=15a7bd23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a7bd23",
  null
  
)

export default component.exports